import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const LoadingSpin = () => {

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
    }}>

      <Spin
        indicator={
          <LoadingOutlined
            style={{
              fontSize: 50,
            }}
            spin
          />
        }
      />
    </div>
  );
};

export default LoadingSpin;
